// extracted by mini-css-extract-plugin
export default {"info-list":"t1wE6dK4T89crXt7ZG8QzA=="};